import theme from '../adminTheme';

const spinnerStyle = {
  display: 'inline-block',
  width: 32,
  height: 32,
  border: '3px solid #e0e0e0',
  borderTopColor: theme.btnPrimary?.background || '#1a4d8c',
  borderRadius: '50%',
  animation: 'adminSpinner 0.8s linear infinite'
};

/**
 * Spinner de carga para el panel admin.
 */
const AdminSpinner = ({ label = 'Cargando...' }) => (
  <div style={theme.loading}>
    <span style={spinnerStyle} aria-hidden="true" />
    {label && (
      <p style={{ marginTop: 12, marginBottom: 0, color: '#666' }}>{label}</p>
    )}
    <style>{`
      @keyframes adminSpinner {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

export default AdminSpinner;
